import React from "react";
import Navbar from "../components/Navbar";
// import { useRef } from "react";
import Footer from "../components/Footer";
import check from "../assets/imgTwo/checkIcon.svg";
import list from "../assets/imgTwo/listIcon.svg";

const Privacy = () => {

  return (
    <>
      <div className="">
        <div className="sticky top-0 z-10">
          <Navbar className="" />
        </div>
        <div className="flex flex-col items-center justify-center text-center mb-8 mt-24">
          <div className="relative flex flex-col items-center justify-center text-center md:w-[45em] h-[11em]">
            <span className="absolute left-0 top-0">
              <img src={check} alt="icon" />
            </span>
            <h2 className="text-center font-bold text-6xl my-6">Terms of Service</h2>
            <span className="absolute right-0 bottom-0">
              <img src={list} alt="icon" />
            </span>
          </div>
        </div>

        <div className="flex-grow max-w-[83rem] md:mx-auto w-full">
          <div className="flex">
            <div className="w-full">
              <div className="md:">

                <div className="p-4">
                  <div className="mb-8" >
                    <h2 className="text-4xl font-bold mb-6" id="terms">
                      Terms of Use
                    </h2>
                    <h2 className="text-2xl font-bold mt-4 mb-4">
                      Uniswitch Technology Merchant Terms of Service
                    </h2>
                    <p className="leading-[2rem]">
                      Uniswitch Technology reserves the right to update and change the
                      Terms of Service from time to time without notice. Any new features
                      that augment or enhance the current Program, including the release
                      of new tools and resources, shall be subject to the Terms of Service.
                      Continued use of the Program after any such changes shall constitute
                      your consent to such changes. Violation of any of the terms below
                      will result in the termination of Merchant Account and forfeiture
                      of any outstanding commission payments earned during the violation.
                    </p>
                  </div>
                  <div className="mb-8" >
                    <h2 className="text-2xl font-bold mb-4">Account Terms</h2>
                    <p className="leading-[2rem]">
                      You must be 18 years or older to be part of this Program.
                      You must provide your legal full name, a valid email address,
                      and any other information requested in order to complete the signup
                      process. Your login may only be used by one person – a single
                      login shared by multiple people is not permitted. You are responsible
                      for maintaining the security of your account and password. Uniswitch
                      Technology Limited cannot and will not be liable for any loss or
                      damage from your failure to comply with this security obligation.
                      You are responsible for all activities that occur under your account.
                      One person or legal entity may not maintain more than one account.
                      You may not use the Merchant service for any illegal or unauthorized
                      purpose. In the use of the Service, you must not violate any laws
                      in your jurisdiction.
                    </p>
                  </div>

                  <div className="mb-8" >
                    <h2 className="text-2xl font-bold mb-4">
                      Merchant Responsibilities
                    </h2>
                    <p className="leading-[2rem]">
                      Merchants and Payment Facilitators will be solely responsible for the
                      operation and maintenance of their infrastructure and system.
                    </p>
                  </div>
                  <div className="mb-8">
                    <h2 className="text-2xl font-bold mb-4">
                      Terms of the Agreements and Program
                    </h2>
                    <p className="leading-[2rem]">
                      The terms of this Agreement will begin upon registration as a Merchant and
                      will end when terminated by either party. Either Uniswitch or yourself may
                      terminate this Agreement at any time, with or without cause, by giving
                      the other party written notice of termination. Upon the termination of
                      this Agreement for any reason, you will immediately cease use of and
                      return all Uniswitch’s materials provided by or on behalf of us to you
                      pursuant hereto or in connection with the Program.
                    </p>
                  </div>
                  <div className="mb-8" >
                    <h2 className="text-2xl font-bold mb-4">
                      Limitations of Liability
                    </h2>
                    <p className="leading-[2rem]">
                      We will not be liable for indirect, special, or consequential damages
                      (or any loss of revenue, profits, or data) arising in connection with
                      this Agreement or the Program, even if we have been advised of the
                      possibility of such damages.
                    </p>
                  </div>
                  <div className="mb-8" >
                    <h2 className="text-2xl font-bold mb-4">Miscellaneous</h2>
                    <p className="leading-[2rem]">
                      This Agreement will be governed by the laws of the State, without
                      reference to rules governing the choice of laws. You may not assign
                      this Agreement by law or otherwise without our prior written consent.
                      Subject to that restriction, this Agreement will be binding on, inure
                      to the benefit of, and be enforceable against the parties and their
                      respective successors and assigns. Our failure to enforce your strict
                      performance of any provision of this Agreement will not constitute a
                      waiver of our right to subsequently enforce such provision or any
                      other provision of this Agreement.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer className="isms-footer" />

    </>

  );
};

export default Privacy;
